<div *ngIf="!selectedFile; else filePreview" class="drop-area" [class.highlight]="isHighlighted"
    (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
    <p class="instruction">
        {{'excel-file-uploader.title' |translate}}
    </p>

    <input type="file" #fileInput="" accept=".xls,.xlsx,.csv" (change)="onFileSelected($event)" hidden />

    <button class="cta-button" type="button" (click)="fileInput.click()">
        {{'excel-file-uploader.browse-btn' |translate}}
    </button>
</div>

<ng-template #filePreview>
    <div class="file-preview">
        <img src="../../../assets/icons/excel-green.svg" alt="Excel File" class="excel-icon" />
        <p class="file-name">{{ selectedFile?.name }}</p>
        <button class="clear-button" (click)="clearFile()">
            {{'excel-file-uploader.clear-btn' |translate}}
        </button>
    </div>
</ng-template>